import { render, staticRenderFns } from "./PopoverInitContentScroll.vue?vue&type=template&id=d72aba84&scoped=true"
import script from "./PopoverInitContentScroll.vue?vue&type=script&lang=js"
export * from "./PopoverInitContentScroll.vue?vue&type=script&lang=js"
import style0 from "./PopoverInitContentScroll.vue?vue&type=style&index=0&id=d72aba84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72aba84",
  null
  
)

export default component.exports